import React, { Component } from 'react';
import './CuadriculaSinopsis.css';
import TarjetaSinopsis from '../Miscelanea/TarjetaSinopsis';

class Tops extends Component {

    constructor(props) {
        super(props);
        this.state = {
            indiceTarjetaSeleccionada: null

        };
    }

    componentDidMount() {

    }

    render() {

        let tarjetas = [];

        if (this.props.tarjetas) {
            tarjetas = this.props.tarjetas.map((e, i) => {
                return <TarjetaSinopsis key={i} datos={e} indice={i}
                    indiceSeleccionado={this.state.indiceTarjetaSeleccionada}
                    mostrarTarjetaInfo={(indice) => { this.setState({ indiceTarjetaSeleccionada: indice }) }}
                    ocultarTarjetaInfo={(indice) => { this.setState({ indiceTarjetaSeleccionada: null }) }}
                />
            })
        }

        return (
            <div className="contenedor-cuadricula-sinopsis tops">
                <div className="encabezado-cuadricula-sinopsis">
                    <p>Tops</p>
                    <hr />
                </div>
                <div className="cuadricula-sinopsis">
                    {tarjetas}
                </div>
            </div>

        )
    }

    componentDidUpdate() {

    }

}

export default Tops;